import { LEGAL_URLS, NEW_TAB } from '../lib/brand.js';

/**
 * The line under every button that creates an account - D-14 ruling 9.
 *
 * > Marketing contact rests on legitimate interest, not consent. Business
 * > accounts are told at signup that they will receive product and pricing
 * > updates and can unsubscribe at any time; the Privacy policy names the basis.
 * > **No consent checkbox**, and no consent language inside the Terms.
 *
 * So this is a statement rather than a control. There is nothing to tick,
 * because there is nothing being asked: the operator has taken the position that
 * telling a business customer plainly is the basis, and a checkbox would imply a
 * choice the policy does not turn on.
 *
 * **The portal still sends no marketing email** (CLAUDE.md, Email, ruling 1).
 * This line describes what the operator may do with the address, not something
 * this codebase does. The unsubscribe will be owned by the CRM when one exists,
 * which is deferred out of this change order entirely.
 *
 * One component rather than the same sentence twice, so the wording an invited
 * agency reads and the wording a self-signed-up one reads cannot drift.
 *
 * **Both links point at the website** - D-15, 22 September 2026. The portal
 * carried its own Terms and Privacy until Phase B; the website is the master
 * now, and these go straight there rather than through the portal's own routes,
 * because somebody deciding whether to create an account should read the
 * document itself rather than a page that forwards them to it.
 *
 * The Privacy page is what makes ruling 9 hold up: with no consent checkbox,
 * the basis for the updates has to be readable by somebody who has no account
 * yet.
 */
export function SignupTermsLine(): React.JSX.Element {
  return (
    <p className="mt-4 text-xs text-fg-muted">
      By creating an account you agree to the{' '}
      <a {...NEW_TAB} href={LEGAL_URLS.terms} className="underline hover:text-fg-2">
        Terms
      </a>
      . We&rsquo;ll also send you{' '}
      <a {...NEW_TAB} href={LEGAL_URLS.privacy} className="underline hover:text-fg-2">
        product and pricing updates
      </a>
      ; unsubscribe any time.
    </p>
  );
}
